module.exports = __webpack_public_path__ + "uPQDIod2JOJYdqZ-K/map-marker.svg";